import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
const savedLanguage = localStorage.getItem('selectedLanguage');
const browserLanguage = navigator.language.split('-')[0];
import LanguageDetector from 'i18next-browser-languagedetector';
import { registerProwlI18n } from '@aplicy-com/prowl-components';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: savedLanguage || browserLanguage || 'en',
    fallbackLng: 'en',
    supportedLngs: ['en', 'fr'],
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: '/locales/{{lng}}/translation1.json',
    },
  });

// Merges prowl-components' bundled en/fr strings into the "prowl" namespace.
// Without this, keys like serviceCardList.empty render as raw i18n keys.
registerProwlI18n(i18n);

// Keep <html lang> in sync with the active language for accessibility & SEO.
const applyHtmlLang = (lng: string) => {
  const base = (lng || 'en').split('-')[0];
  document.documentElement.lang = base;
};
applyHtmlLang(i18n.language || savedLanguage || browserLanguage || 'en');
i18n.on('languageChanged', applyHtmlLang);

export default i18n;
